import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Layout from "@/components/layout/Layout";
import { api, shortHash, formatNumber } from "@/lib/api";
import { Coins, TrendingUp, TrendingDown } from "lucide-react";

export default function Tokens() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/tokens").then((r) => setItems(r.data.items));
    const iv = setInterval(() => api.get("/tokens").then((r) => setItems(r.data.items)), 20000);
    return () => clearInterval(iv);
  }, []);
  return (
    <Layout>
      <div className="flex items-center gap-3 mb-2">
        <Coins className="text-[var(--ks-primary)]" />
        <h1 className="text-xl font-semibold">Top ERC-20 Tokens</h1>
      </div>
      <p className="text-sm text-[var(--ks-text-soft)] mb-4">Prices from Kraken (LINK) · stablecoins pegged to $1.00 · KDR is Etherscan&apos;s native token.</p>
      <div className="ks-card overflow-hidden">
        <div className="overflow-x-auto">
          <table className="ks-table" data-testid="tokens-table">
            <thead>
              <tr>
                <th>#</th><th>Token</th><th>Price</th><th>Change (24h)</th><th>Holders</th><th>Supply</th><th className="text-right">Contract</th>
              </tr>
            </thead>
            <tbody>
              {items.map((t, i) => (
                <tr key={t.contract} data-testid={`tokens-row-${t.symbol}`}>
                  <td>{i + 1}</td>
                  <td>
                    <Link to={`/token/${t.contract}`} className="ks-link font-medium">{t.name}</Link>
                    <div className="text-xs text-[var(--ks-text-soft)]">{t.symbol} · {t.type}</div>
                  </td>
                  <td>${t.price_usd?.toFixed(t.price_usd < 10 ? 4 : 2)}</td>
                  <td>
                    <span className={t.change_pct >= 0 ? "text-[var(--ks-success)]" : "text-[var(--ks-failed)]"}>
                      {t.change_pct >= 0 ? <TrendingUp size={12} className="inline"/> : <TrendingDown size={12} className="inline"/>}
                      {" "}{t.change_pct >= 0 ? "+" : ""}{t.change_pct}%
                    </span>
                  </td>
                  <td>{formatNumber(t.holders)}</td>
                  <td>{formatNumber(t.total_supply)}</td>
                  <td className="text-right mono text-xs">
                    <Link to={`/token/${t.contract}`} className="ks-link">{shortHash(t.contract, 10, 8)}</Link>
                  </td>
                </tr>
              ))}
              {items.length === 0 && <tr><td colSpan={7} className="text-center py-8 text-[var(--ks-text-soft)]">Loading…</td></tr>}
            </tbody>
          </table>
        </div>
      </div>
    </Layout>
  );
}
